import { atom } from 'recoil';

const SelectedDetailTab = atom({
  key: 'SelectedDetailTab',
  default: '포지션 소개',
});

export { SelectedDetailTab };
